var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ce-chapter-select',{staticClass:"mt-6 mt-lg-8",attrs:{"chapters":_vm.chapters,"activeChapter":_vm.activeChapter},scopedSlots:_vm._u([{key:"heading",fn:function(){return [_vm._t("headline")]},proxy:true},{key:"you-are-here",fn:function(){return [_vm._t("you-are-here")]},proxy:true}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }